'use strict';
define('polyfill/resize-sensor',['element-resize-detector'], function (elementResizeDetectorMaker) {
	var erdUltraFast = elementResizeDetectorMaker({
		strategy: "scroll" //<- For ultra performance.
	});

	window.ResizeSensor = function (element, callback) {
		erdUltraFast.listenTo(element, callback);
	};
	window.ResizeSensor.detach = function (element) {
		console.log('detach request', element);
	};
});
